import { render, staticRenderFns } from "./catalogueLub.vue?vue&type=template&id=4a39ef71&scoped=true&"
import script from "./catalogueLub.vue?vue&type=script&lang=js&"
export * from "./catalogueLub.vue?vue&type=script&lang=js&"
import style0 from "./catalogueLub.vue?vue&type=style&index=0&id=4a39ef71&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a39ef71",
  null
  
)

export default component.exports